import { ref } from 'vue';
import type { ApiConfig } from '../../../composables/useApi';
import { imagesApi } from '../services/images.api';

export type UploadItem = { key: string; file?: File; previewUrl: string; id?: string; filename?: string; existing?: boolean };

export function useImageQueue() {
  const items = ref<UploadItem[]>([]);
  const uploading = ref(false);

  function reset() {
    for (const it of items.value) {
      if (it.previewUrl && it.file) URL.revokeObjectURL(it.previewUrl);
    }
    items.value = [];
  }

  function setExistingImages(imgs: Array<{ id?: string; filename?: string; url: string; is_cover?: number }>) {
    items.value = [];
    for (const img of imgs) {
      const url = img?.url;
      if (!url) continue;
      items.value.push({
        key: `${Date.now()}-${Math.random()}`,
        previewUrl: url,
        id: img.id,
        filename: img.filename,
        existing: true,
      });
    }
  }

  function addFiles(files: File[]) {
    for (const f of files) {
      if (!f.type.startsWith('image/')) continue;
      const url = URL.createObjectURL(f);
      items.value.push({ key: `${Date.now()}-${Math.random()}`, file: f, previewUrl: url });
    }
  }

  function moveItem(from: number, to: number) {
    if (from === to) return;
    const arr = items.value;
    const it = arr.splice(from, 1)[0];
    arr.splice(to, 0, it);
  }

  async function uploadAll(api: ApiConfig, offerId: number) {
    if (uploading.value) return;
    uploading.value = true;
    try {
      for (const [index, it] of items.value.entries()) {
        if (!it.file) continue;
        await imagesApi.upload(api, {
          file: it.file,
          offerId,
          position: index,
          is_cover: index === 0 ? 1 : 0,
        });
      }
    } finally {
      uploading.value = false;
    }
  }

  return { items, uploading, reset, setExistingImages, addFiles, moveItem, uploadAll };
}
